import React, { useState } from "react";

interface ImageComponentProps {
  src: string | string[];
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLImageElement>) => void;
  [key: string]: any;
}

const ImageComponent = React.forwardRef<HTMLImageElement, ImageComponentProps>(
  ({ src, className, onClick, ...props }, ref) => {
    const isArray = Array.isArray(src);
    const initialSrc = isArray ? src[0] : src;
    const [hasErrored, setHasErrored] = useState(false);

    const getSrcSet = (): string | undefined => {
      if (isArray) {
        return src.map((item, index) => `${item} ${index + 1}x`).join(", ");
      } else {
        return undefined;
      }
    };

    const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
      const img = e.currentTarget;

      console.warn("Image failed to load:", img);
      if (!hasErrored && img.src.endsWith(".webp")) {
        const fallbackSrc = img.src.replace(/\.webp$/i, ".png");
        console.log("Falling back to:", fallbackSrc);
        img.src = fallbackSrc;
        img.srcset = "";
        setHasErrored(true);
      }
    };

    const handleLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
      console.log("Image loaded:", event.currentTarget.currentSrc);
    };

    return (
      <img
        ref={ref}
        src={initialSrc}
        srcSet={getSrcSet()}
        alt="Responsive Image"
        className={className}
        onClick={onClick}
        onError={handleError}
        onLoad={handleLoad}
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        style={{
          userSelect: "none",
          pointerEvents: "auto",
          touchAction: "manipulation",
          WebkitUserSelect: "none",
          WebkitTouchCallout: "none",
        }}
        {...props}
      />
    );
  }
);

export default ImageComponent;
